import { createContext, useContext } from 'react';

const SeasonalDashboardContext = createContext(null);

export const useSeasonalDashboardContext = () =>
  useContext(SeasonalDashboardContext);

export default SeasonalDashboardContext;
